import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES, RESET_PASSWORD_TOKEN } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { makeRequest } from '../../api/api';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { customToast } from '../../constant/constant';

export const sendResetEmail = createAsyncThunk( 
  'forgotPasswordSlice/sendResetEmail',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.RESET_PASSWORD_EMAIL,
          wstoken: RESET_PASSWORD_TOKEN // token for reset email permissions
        }
      );
      if (response?.data?.notice?.length > 0) {
        customToast(
          'Sent',
          `Reset link has been sent to your registered email.`,
          'success',
          5000
        );
      } else {
        customToast(
          'Failure',
          'Please enter a valid email address.',
          'error',
          3000
        );
      }

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const verifyResetToken = createAsyncThunk(
  'forgotPasswordSlice/verifyResetToken',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.FORGOT_PASSWORD_VALIDATE_TOKEN,
          wstoken: RESET_PASSWORD_TOKEN // token for reset email permissions
        }
      );
      //   console.log(response?.data);

      if (response?.data?.error) {
        customToast(
          'Failure',
          'Reset link has expired. Please try again.',
          'error',
          5000
        );
      }

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const resetPassword = createAsyncThunk(
  'forgotPasswordSlice/resetPassword',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.RESET_PASSWORD,
          wstoken: RESET_PASSWORD_TOKEN // token for reset email permissions
        }
      );
      //   console.log(response?.data);

      if (response?.data?.success) {
        customToast(
          'Success',
          `Password updated successfully.`,
          'success',
          3000
        );
      } else {
        customToast(
          'Failure',
          'Something went wrong! Please try again.',
          'error',
          5000
        );
      }
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const forgotPasswordSlice = createSlice({
  name: 'forgotPasswordSlice',
  initialState: {
    sendResetEmail: {
      isLoading: false,
      error: null,
      data: null
    },
    verifyResetToken: {
      isLoading: false,
      error: null,
      data: {}
    },
    resetPassword: {
      isLoading: false,
      error: null,
      data: {}
    }
  },
  reducers: {
    setActivityData: (state, action) => {
      Object.keys(action.payload).map((val) => {
        state[val] = action.payload[val];
      });
    }
  },
  extraReducers: (builder) => {
    builder.addCase(sendResetEmail.pending, (state) => {
      state.sendResetEmail.isLoading = true;
    });
    builder.addCase(sendResetEmail.fulfilled, (state, action) => {
      state.sendResetEmail.isLoading = false;
      state.sendResetEmail.data = action?.payload || [];
    });
    builder.addCase(sendResetEmail.rejected, (state) => {
      state.sendResetEmail.isLoading = false;
    });
    ///////////////////////////////////////////////////////////////////////////
    builder.addCase(verifyResetToken.pending, (state) => {
      state.verifyResetToken.isLoading = true;
    });
    builder.addCase(verifyResetToken.fulfilled, (state, action) => {
      state.verifyResetToken.isLoading = false;
      state.verifyResetToken.data = action?.payload || {};
    });
    builder.addCase(verifyResetToken.rejected, (state) => {
      state.verifyResetToken.isLoading = false;
      state.verifyResetToken.error = action?.payload?.error;
    });
    ///////////////////////////////////////////////////////////////////////////
    builder.addCase(resetPassword.pending, (state) => {
      state.resetPassword.isLoading = true;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.resetPassword.isLoading = false;
      state.resetPassword.data = action?.payload || {};
    });
    builder.addCase(resetPassword.rejected, (state) => {
      state.resetPassword.isLoading = false;
      state.resetPassword.error = action?.payload?.error;
    });
  }
});

export const { setActivityData } = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
